import {useStore} from '@nanostores/react'

import {$experiments} from '@/utils/experiments-client'

/**
 * Returns the regex source for every running page-split experiment, read reactively from
 * the experiments store. Empty until experiments load; re-renders when they arrive so
 * LocalizedLink can switch matching links to a hard navigation.
 */
export const usePageSplitExperimentPaths = (): string[] => {
    const {paths} = useStore($experiments)
    return paths
}
